function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "check_svg__a",
  d: "M14.809.219a.75.75 0 111.06 1.062L6 11.125a.75.75 0 01-1.05.01L.23 6.586a.75.75 0 111.04-1.08l4.191 4.037L14.81.219z"
}));
var _ref3 = /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  stroke: "#FFF",
  transform: "translate(1 1)",
  xlinkHref: "#check_svg__a"
});
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.db800682.svg";
export { ForwardRef as ReactComponent };